import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { App } from './App';
import { Adv1Page } from './pages/Adv1Page';
export function AppRouter() {
  return <BrowserRouter data-id="element-18">
      <Routes data-id="element-19">
        <Route path="/" element={<App data-id="element-21" />} data-id="element-20" />
        <Route path="/adv-1" element={<Adv1Page data-id="element-23" />} data-id="element-22" />
      </Routes>
    </BrowserRouter>;
}